export default __webpack_public_path__ + "static/media/analyze-image.d3827164.png";